import { ActionState, ActionStateEnum, EditModeEnum, IdleCreateState, EditCoteState, EditWallState, EditJoineryState, EditPointState, EditEntityState, AddEntityState, AddRoomState, AddJoineryState, AreaState } from "..";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { EntityManager } from "../../plan/EntityManager";
import { GUIConstants } from "../../utils/GUIConstants";
import { Utils } from "../../utils/Utils";

import { IdleEditState } from './IdleEditState'
import { PlanManager } from "../../../../cocosPlan";
import { CeilingBox, Commands, Comment, ComponentConstants, Door, EntityDefaultPropertiesManager, EntityFactory, Events, eventsManager, FunctionalityChip, GeometryPrimitive, Joinery, joineryManager, Listener, math, Niche, planManager, Room, roomManager, SavaneConstants, SavaneMath, SceneConstants, Staircase, TechnicalElement, Wall, wallManager, Window } from "@rhinov/savane-js";

declare var cc: any;

export class IdleConstruction extends IdleEditState {

    justDeleted: number = -42;
    clickDownHappened: boolean = false;
    deleteListener: Listener;
    unselectListener: Listener;
    plusListener: Listener;
    lessListener: Listener;
    sliderListener: Listener;
    textFieldListener: Listener;
    textFieldEndListener: Listener;
    chipFuncAddListener: Listener;
    chipFuncRemoveListener: Listener;
    chipFuncEditionListener: Listener;
    entityEdition: Listener;
    componentEdition: Listener;

    hasBeenEdited: boolean = false;
    // Is in mode scale (V pressed or not)
    scaleModeOn: boolean = false;
    // Is in mode rotate (R pressed or not)
    rotateModeOn: boolean = false;
    // Is in mode symetry (S pressed or not)
    symetryModeOn: boolean = false;
    // Is in translate mode (T pressed or not)
    translateModeOn: boolean = false;

    shiftPressed: boolean = false;
    ctrlPressed: boolean = false;
    chipEdited: any;

    renameRoomArray: Array<{keyCode: any, functionalityId: number, functionalityName: string}> = [
        {keyCode: cc.KEY.a, functionalityId: ComponentConstants.Functionalities.Driveway, functionalityName: 'Allée'},

        {keyCode: cc.KEY.b, functionalityId: ComponentConstants.Functionalities.Office, functionalityName: 'Bureau'},
        {keyCode: cc.KEY.b, functionalityId: ComponentConstants.Functionalities.Balcony, functionalityName: 'Balcon'},
        {keyCode: cc.KEY.b, functionalityId: ComponentConstants.Functionalities.Laundryroom, functionalityName: 'Buanderie'},
        
        {keyCode: cc.KEY.c, functionalityId: ComponentConstants.Functionalities.Kitchen, functionalityName: 'Cuisine'},
        {keyCode: cc.KEY.c, functionalityId: ComponentConstants.Functionalities.Bedroom, functionalityName: 'Chambre adulte'},
        {keyCode: cc.KEY.c, functionalityId: ComponentConstants.Functionalities.TeenagerBedroom, functionalityName: 'Chambre adolescent'},
        {keyCode: cc.KEY.c, functionalityId: ComponentConstants.Functionalities.KidBedroom, functionalityName: 'Chambre enfant'},
        {keyCode: cc.KEY.c, functionalityId: ComponentConstants.Functionalities.BabyBedroom, functionalityName: 'Chambre bébé'},
        {keyCode: cc.KEY.c, functionalityId: ComponentConstants.Functionalities.Cellar, functionalityName: 'Cellier'},

        {keyCode: cc.KEY.d, functionalityId: ComponentConstants.Functionalities.Clearance, functionalityName: 'Dégagement'},
        {keyCode: cc.KEY.d, functionalityId: ComponentConstants.Functionalities.Dressing, functionalityName: 'Dressing'},

        {keyCode: cc.KEY.e, functionalityId: ComponentConstants.Functionalities.Doorway, functionalityName: 'Entrée'},

        {keyCode: cc.KEY.g, functionalityId: ComponentConstants.Functionalities.TechnicalRoom, functionalityName: 'Gaine technique'},
        {keyCode: cc.KEY.g, functionalityId: ComponentConstants.Functionalities.Garage, functionalityName: 'Garage'},

        {keyCode: cc.KEY.j, functionalityId: ComponentConstants.Functionalities.Garden, functionalityName: 'Jardin'},

        {keyCode: cc.KEY.m, functionalityId: ComponentConstants.Functionalities.Mezzanine, functionalityName: 'Mezzanine'},

        {keyCode: cc.KEY.p, functionalityId: ComponentConstants.Functionalities.LivingDiningroom, functionalityName: 'Pièce de vie'},
        {keyCode: cc.KEY.p, functionalityId: ComponentConstants.Functionalities.Patio, functionalityName: 'Patio'},
        {keyCode: cc.KEY.p, functionalityId: ComponentConstants.Functionalities.Pool, functionalityName: 'Piscine'},
        {keyCode: cc.KEY.p, functionalityId: ComponentConstants.Functionalities.Wardrobe, functionalityName: 'Penderie'},

        {keyCode: cc.KEY.s, functionalityId: ComponentConstants.Functionalities.Diningroom, functionalityName: 'Salle à manger'},
        {keyCode: cc.KEY.s, functionalityId: ComponentConstants.Functionalities.Bathroom, functionalityName: 'Salle de bain'},
        {keyCode: cc.KEY.s, functionalityId: ComponentConstants.Functionalities.Livingroom, functionalityName: 'Salon'},
        {keyCode: cc.KEY.s, functionalityId: ComponentConstants.Functionalities.ParentalSuite, functionalityName: 'Suite parentale'},
        {keyCode: cc.KEY.s, functionalityId: ComponentConstants.Functionalities.GameRoom, functionalityName: 'Salle de jeux'},

        {keyCode: cc.KEY.t, functionalityId: ComponentConstants.Functionalities.Terrace, functionalityName: 'Terrasse'},

        {keyCode: cc.KEY.v, functionalityId: ComponentConstants.Functionalities.Void, functionalityName: 'Vide sur pièce'},
        {keyCode: cc.KEY.v, functionalityId: ComponentConstants.Functionalities.Veranda, functionalityName: 'Verranda'},

        {keyCode: cc.KEY.w, functionalityId: ComponentConstants.Functionalities.Watercloset, functionalityName: 'WC'}
    ];

    constructor(chipSelected?: any) {
        super();
        this.state = ActionStateEnum.IdleConstruction;
        

        //Attach listeners
        this.deleteListener = eventsManager.instance.addListener(Events.DELETE_EVENT, this.actionDelete.bind(this))!;
        this.unselectListener = eventsManager.instance.addListener(Events.UNSELECT_PRESSED, this.actionEditEnded.bind(this))!;
        this.plusListener = eventsManager.instance.addListener(Events.PLUS_CLICKED, this.plusOrLessClickedHandler.bind(this))!;
        this.lessListener = eventsManager.instance.addListener(Events.LESS_CLICKED, this.plusOrLessClickedHandler.bind(this))!;
        this.sliderListener = eventsManager.instance.addListener(Events.SLIDER_BUTTON, this.sliderButtonHandler.bind(this))!;
        this.textFieldListener = eventsManager.instance.addListener(Events.TEXTFIELD_EDIT, (event: any) => {
            this.actionTextFieldEdit(event.getUserData().editedProperty, event.getUserData().value, event.getUserData().obj);
        })!;
        this.textFieldEndListener = eventsManager.instance.addListener(Events.TEXTFIELD_EDIT_ENDED, (event: any) => {
            this.actionTextFieldEditEnded(event.getUserData().editedProperty, event.getUserData().value, event.getUserData().obj);
        })!;
        //Listen for func chip add
        this.chipFuncAddListener = new Listener((data: any) => {
            (this as any).addRoomFunc(data.userData.functionality, data.userData.room, data.userData.edit);
        });
        eventsManager.instance.addListenerObject(Events.ADD_ROOM_SECONDARY_FUNCTIONALITY, this.chipFuncAddListener);

        //Listen for func chip remove
        this.chipFuncRemoveListener = new Listener((data: any) => {
            (this as any).removeRoomFunc(data.userData.functionality, data.userData.room, data.userData.edit);
        });
        eventsManager.instance.addListenerObject(Events.REMOVE_ROOM_SECONDARY_FUNCTIONALITY, this.chipFuncRemoveListener);

        //Listen for func chip edition
        this.chipFuncEditionListener = new Listener((data: any) => {
            (this as any).changeToChipFunctionalityEdition(data.userData.functionality, data.userData.room, true);
        });
        eventsManager.instance.addListenerObject(Events.CHIP_FUNC_EDITION, this.chipFuncEditionListener);

        //Listener for edit/create entity
        this.entityEdition = new Listener((data: any) => {
            this.changeToEntityEdition(data.userData.entity);
        });
        eventsManager.instance.addListenerObject(Events.ENTITY_EDITION, this.entityEdition);

        this.componentEdition = new Listener((data: any) => {
            this.changeToComponentEdition(data.userData);
        });
        eventsManager.instance.addListenerObject(Events.COMPONENT_EDITION, this.componentEdition);

        this.selectedItem = null;
        if (PlanManager.getInstance().selectedEntities != null &&
            PlanManager.getInstance().selectedEntities.length > 0) {
            this.selectedItem = PlanManager.getInstance().selectedEntities[0];
        }

        this.unselectChip();
        if (chipSelected !== null && chipSelected !== undefined) {
            this.chipEdited = chipSelected;
            //set state to selected
            var layer = PlanManager.getInstance().scrollWindow.grid;
            var name = 'FunctionalityChip' + this.chipEdited.id;
            // var sprite = layer.getChildByName(name);
            var sprite = Utils.getChildByNameRecursivly(layer, name);
            if (sprite !== null) {
                sprite.setSelected(true);
            }
        }
        
    }

    initialize() {
        //enabled grid visibility
        if (PlanManager.getInstance().scrollWindow.grid.getGridVisibility() === false) {
            PlanManager.getInstance().mustShowGrid = true;
            PlanManager.getInstance().scrollWindow.grid.setGridVisibility(true);
            PlanManager.getInstance().scrollWindow.refreshGrid();
        }

        eventsManager.instance.dispatch(Events.HIDE_BACKGROUND_PRESSED, true);
        PlanManager.getInstance().mustShowPlan = true;
        eventsManager.instance.dispatch(Events.TOGGLE_PLAN, true);
    }

    getAction() {
        return ActionStateEnum.IdleConstruction;
    }

    mouseClickCancelled(cursorPosition: math.vec3) {
        PlanManager.getInstance().scrollWindow._cancelDragging();
        return null;
    }

    mouseClickDown(cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: any[], mouseButton: number): ActionState | null {
        this.clickDownHappened = true;
        var pm = PlanManager.getInstance();
        var obj = GameObjectManager.getObjectOfClickedDimension();
        if (obj !== null) {
            this.dispose();//FIXME already executed in => PlanManager->mouseClickDown
            return new EditCoteState(obj);
        }
        //        this.findLastValue();
        this.actionEditEnded();

        this.unselectChip();
        if (cursorPosition === null) {
            return null;
        }

        // Keep only what's necessary in the entitiesHover array
        if (hoverEntities !== null && hoverEntities.length !== 0) {
            for (var i = 1 ; i < hoverEntities.length ; i++) {
                if (hoverEntities[0].entityType !== hoverEntities[i].entityType) {
                    hoverEntities = hoverEntities.splice(0, 0);
                    break;
                }
            }
        }

        if (this.ctrlPressed && hoverEntities.length > 0 && pm.selectedEntities != null && pm.selectedEntities.length > 0 && pm.selectedEntities[0].entityType === hoverEntities[0].entityType) {
            pm.updateItemsSelected(pm.selectedEntities.concat(hoverEntities), false, false);
            return(null);
        }
        if (pm.selectedEntities != null && pm.selectedEntities.length > 0 && (pm.selectedEntities[0] instanceof Staircase
            || pm.selectedEntities[0] instanceof TechnicalElement || pm.selectedEntities[0] instanceof Comment || pm.selectedEntities[0] instanceof GeometryPrimitive)) {
            var node = EntityManager.getInstance().getNode(pm.selectedEntities[0]);
            var boundingBox = pm.selectedEntities[0].boundingBox;
            if (node !== null && (node.toRotate(pm._uiState.unsnappedCursorPosition) || node.toResize(pm._uiState.unsnappedCursorPosition) !== false || SavaneMath.isInPoly(cursorPosition, boundingBox))) {
                return new EditEntityState(pm.selectedEntities[0], cursorPosition, node.toRotate(pm._uiState.unsnappedCursorPosition), EditModeEnum.rotate, node.toResize(pm._uiState.unsnappedCursorPosition));
            }
        }
        pm.updateItemsSelected(null);

        var area = planManager.getAreaAtPosition(cursorPosition, [
            ComponentConstants.ComponentType.Area,
            ComponentConstants.ComponentType.FloorCoatingArea,
        ], false, pm.world.currentScene!.currentFloor!);
        if (area !== null && (hoverEntities === null || hoverEntities.length <= 0 || hoverEntities[0].entityType === SceneConstants.EntityType.Room)) {

            if (hoverEntities.length > 0 && hoverEntities[0].entityType === SceneConstants.EntityType.Room) {
                var node = EntityManager.getInstance().getNode(hoverEntities[0]);

                if (!node || !node.roomNameLabel.isClickIn(pm.scrollWindow.grid.convertToWorldSpace(GameObjectManager.convertToCocosCoord(cursorPosition)))) {
                    eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.DrawArea);
                    return new AreaState(area, cursorPosition);
                }
            } else {
                eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.DrawArea);
                return new AreaState(area, cursorPosition);
            }
        }
        if (hoverEntities !== null && hoverEntities.length > 0) {
            var entity = hoverEntities[0];
            if (entity.isJoineryEntity() && entity.id != this.justDeleted) {
                this.dispose();//FIXME already executed in => PlanManager->mouseClickDown
                return new EditJoineryState(entity, cursorPosition);
            } else if (entity.isWallEntity()) {
                var testedWallId = true;
                for (var i = 0; i < hoverEntities.length; ++i) {
                    if (hoverEntities[i].id === this.justDeleted) {
                        testedWallId = false;
                        break;
                    }
                }
                if (hoverEntities.length === 1 && !hoverEntities[0].isCorner(cursorPosition, Utils.magnetDistance) && testedWallId) {
                    if (doubleClick) {
                        pm.executeCommand(new Commands.CutWallCommand(hoverEntities[0], cursorPosition, pm.selectedEntities));
                        return null;
                    } else {
                        this.dispose();//FIXME already executed in => PlanManager->mouseClickDown
                        return new EditWallState(hoverEntities[0].id);
                    }
                }

                if (testedWallId) {
                    pm.updateItemsSelected(null);
                    this.dispose();

                    // Check if any corner and wall at this position
                    var wallEdited = wallManager.getWallsAtCorner(cursorPosition, pm.world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance);

                    // Yes there is a wall to edit
                    if (wallEdited !== null) {
                        return new EditPointState(cursorPosition);
                    }
                    else {
                        // Search for the wall we are phycically on
                        for (var i = 0; i < hoverEntities.length; i++) {
                            var bbox = hoverEntities[i].boundingBoxCut;
                            bbox.splice(1, 0, hoverEntities[i].begin);
                            bbox.splice(4, 0, hoverEntities[i].end);
                            if (SavaneMath.isInPoly(cursorPosition, bbox)) {
                                break;
                            }
                        }
                        // Securely found
                        if (i < hoverEntities.length) {
                            return new EditWallState(hoverEntities[i].id);
                        }
                        else {
                            return(null);
                        }
                    }
                }
            } else if (entity.isStaircaseEntity() || entity.isTechnicalElementEntity() || entity.isCommentEntity() || entity.isGeometryPrimitiveEntity()) {
                return new EditEntityState(entity, cursorPosition);
            // } else if (entity.isFunctionalityChipEntity()) {
            //     //set state to selected
            //     /*var layer = PlanManager.getInstance().scrollWindow.grid;
            //     var name = entity.id;
            //     var sprite = Utils.getChildByNameRecursivly(layer, name);
            //     if (sprite !== null) {
            //         sprite.setSelected(true);
            //     }*/

            //     this.dispose();
            //     return new MoveFunctionalityChipState(entity.parent, entity, cursorPosition, true);
            } else if (entity.isRenderCameraEntity()) {
                eventsManager.instance.dispatch(Events.COMMAND_EXECUTED, {
                    name: Commands.CommandEnum.EditEntityCommand,
                    undo: false,
                    datas: {
                        id: entity.id,
                        type: entity.entityType,
                        select: true
                    }
                });
            }
        }

        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        pm.scrollWindow._startDragging(posx, posy, true);
        pm.updateItemsSelected(null);
        return null;
    }

    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: any[], mouseButton: number) {
        var downHappened = this.clickDownHappened;
        this.clickDownHappened = false;
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        PlanManager.getInstance().scrollWindow._endDragging(posx, posy, true);

        if (hoverEntities !== null && hoverEntities.length === 1 &&
            hoverEntities[0].isRoomEntity() && hoverEntities[0].id != this.justDeleted) {

            var node = EntityManager.getInstance().getNode(hoverEntities[0]);
            if (!downHappened) {
                return null;
            }
            if (node && node.roomNameLabel.isClickIn(PlanManager.getInstance().scrollWindow.grid.convertToWorldSpace(GameObjectManager.convertToCocosCoord(cursorPosition)))) {
                PlanManager.getInstance().updateItemsSelected([hoverEntities[0]], false, mouseButton === 2);
                return new IdleConstruction();
            } else {
                PlanManager.getInstance().updateItemsSelected([hoverEntities[0]], false, false);
            }

        }
        return null;
    }

    moveMouseCursor(cursorPosition: math.vec3, hoverEntities?: any[], planpos?: any) {
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        PlanManager.getInstance().scrollWindow._mouseDragging(posx, posy, true);
        super.moveMouseCursor(cursorPosition, hoverEntities, planpos);
        return null;
    }

    mouseIdle(cursorPosition: math.vec3, hoverEntities: any[], dt: number): ActionState | null {
        return null;
    }

    // Will unselect any selected item when the ESC key is pressed
    actionEscape() {
        this.selectedItem = null;
        PlanManager.getInstance().updateItemsSelected(null);
        this.unselectChip();
    }

    actionDelete() {
        var planManager = PlanManager.getInstance();
        var currentSelection = planManager.selectedEntities;

        if (currentSelection.length === 0) {
            var backPlan = planManager.world.currentScene!.currentFloor!.getComponent(ComponentConstants.ComponentType.TemplateImage);

            if (backPlan !== null) {
                planManager.executeCommand(new Commands.DeleteComponentCommand(backPlan, false));
            }
        }

        if (currentSelection.length !== 0) {
            if (currentSelection[0].isRoomEntity()) {
                if (this.chipEdited !== null && this.chipEdited !== undefined) {
                    this.chipEdited.isOnPlan = false;
                    GameObjectManager.deleteFunctionalityChip(this.chipEdited);
                } else {
                    planManager.executeCommand(new Commands.DeleteRoomsCommand(currentSelection as Room[], currentSelection));
                    if (this.selectedItem !== null) {
                        this.justDeleted = this.selectedItem.id;
                    }
                }
            }

            if (currentSelection[0].isStaircaseEntity()) {
                planManager.executeCommand(new Commands.DeleteStaircasesCommand(currentSelection as Staircase[]));
                if (this.selectedItem !== null) {
                    this.justDeleted = this.selectedItem.id;
                }
            }

            if (currentSelection[0].isTechnicalElementEntity()) {
                planManager.executeCommand(new Commands.DeleteTechnicalElementsCommand(currentSelection as TechnicalElement[]));
                if (this.selectedItem !== null) {
                    this.justDeleted = this.selectedItem.id;
                }
            }

            if (currentSelection[0].isCommentEntity()) {
                planManager.executeCommand(new Commands.DeleteEntitiesCommand(currentSelection));
                if (this.selectedItem !== null) {
                    this.justDeleted = this.selectedItem.id;
                }
            }

            if (currentSelection[0].isGeometryPrimitiveEntity()) {
                planManager.executeCommand(new Commands.DeleteEntitiesCommand(currentSelection));
                if (this.selectedItem !== null) {
                    this.justDeleted = this.selectedItem.id;
                }
            }

            if (currentSelection[0].isJoineryEntity()) {
                GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint');
                GameObjectManager.deleteJoineryExtremity('SelectedJoineryPoint2');
                planManager.executeCommand(new Commands.DeleteJoineriesCommand(currentSelection as Joinery[]));
                if (this.selectedItem !== null) {
                    this.justDeleted = this.selectedItem.id;
                }
            }

            if (currentSelection[0].isWallEntity()) {
                planManager.executeCommand(new Commands.DeleteWallCommand(currentSelection as Wall[], currentSelection));
                if (this.selectedItem !== null) {
                    this.justDeleted = this.selectedItem.id;
                }
            }
        }

        this.selectedItem = null;
        planManager.updateItemsSelected(null);
    }

    startEdit() {
        if (this.selectedItem !== null) {
            this.selectedItem.startTemporary();
        }
    }

    plusOrLessClickedHandler(event: any) {
        this.selectedItem = event.getUserData().obj;
        if (!this.hasBeenEdited) {
            this.startEdit();
        }
        else {
            if (this.selectedItem !== null && this.selectedItem.temporary) {
                this.selectedItem.temporary.recomputeValidity = true;
            }
        }
        if (this.selectedItem != null) {
            this.capValue(event.getUserData().editedProperty, event.getUserData().value);

            this.actionEditEntity(this.selectedItem);
        }
        this.hasBeenEdited = true;
    }

    getRollingShutter(joinery: any) {
        for (var i = 0; i < joinery.children.length; i++) {
            if (joinery.children[i].entityType === SceneConstants.EntityType.TechnicalElement &&
                joinery.children[i].objectId === SceneConstants.TechnicalElementType.ceilingBox &&
                joinery.children[i].ceilingBoxType === SceneConstants.CeilingBoxType.rollingShutter) {
                return(joinery.children[i]);
            }
        }

        return(null);
    }

    supportRollingShutter(joinery: any) {
        if (joinery.joineryType === SceneConstants.JoineryType.window ||
            joinery.joineryType === SceneConstants.JoineryType.pictureWindow ||
            joinery.joineryType === SceneConstants.JoineryType.frenchWindow ||
            joinery.joineryType === SceneConstants.JoineryType.fixedWindow ||
            joinery.joineryType === SceneConstants.JoineryType.canopy) {
            return(true);
        }

        return(false);
    }

    addRollingShutter(joinery: any) {
        var rollingShutter = EntityFactory.getInstance().createTechnicalElement(SceneConstants.TechnicalElementType.ceilingBox,
            joinery.length, 200, 200, "0", '');
        joinery.addChild(rollingShutter);
        EntityManager.getInstance().addEntity(rollingShutter);

        return(rollingShutter);
    }

    removeRollingShutter(rollingShutter: any) {
        EntityManager.getInstance().removeEntity(rollingShutter);
        rollingShutter.parent.deleteChild(rollingShutter.id, SceneConstants.EntityType.TechnicalElement);
    }

    updateRollingShutterPosition(rollingShutter: any) {
        var position = math.vec3.create();
        var joinery = rollingShutter.parent;

        if (joinery.orientation) {
            math.vec3.set(position, 0, -joinery.parent.thickness / 2, joinery.height + joinery.floorHeight);
        }
        else {
            math.vec3.set(position, 0, joinery.parent.thickness / 2, joinery.height + joinery.floorHeight);
        }
        if (joinery.transom) {
            position[2] = joinery.transomHeight;
        }

        rollingShutter.transform.localPosition = position;
    }

    sliderButtonHandler(event: any) {
        this.selectedItem = event.getUserData().obj;
        if (!this.hasBeenEdited) {
            this.startEdit();
        }
        else {
            if (this.selectedItem !== null && this.selectedItem.temporary) {
                this.selectedItem.temporary.recomputeValidity = true;
            }
        }
        if (this.selectedItem != null) {
            var value = event.getUserData().value;
            if (event.getUserData().editedProperty === GUIConstants.OPENING_MODE) {
                value = value ? SceneConstants.OpeningMode.mode_slide : SceneConstants.OpeningMode.mode_default;
                if (value === SceneConstants.OpeningMode.mode_default) {
                    if ((this.selectedItem as any)[GUIConstants.NB_DOORS] > SceneConstants.MaxDoorJoineryDefault) {
                        (this.selectedItem as any)[GUIConstants.NB_DOORS] = SceneConstants.MaxDoorJoineryDefault;
                    }
                    //if (this.selectedItem[GUIConstants.NB_CASEMENTS] > SceneConstants.MaxDoorJoineryDefault) {
                    //    this.selectedItem[GUIConstants.NB_CASEMENTS] = SceneConstants.MaxDoorJoineryDefault;
                    //}
                }
            } else if (event.getUserData().editedProperty === GUIConstants.SHUTTER) {
                var rollingShutter = this.getRollingShutter(this.selectedItem);

                if (event.getUserData().value === false) {
                    if (rollingShutter !== null) {
                        this.removeRollingShutter(rollingShutter);
                    }
                } else {
                    if (rollingShutter === null) {
                        rollingShutter = this.addRollingShutter(this.selectedItem);
                    }
                    this.updateRollingShutterPosition(rollingShutter);
                }
            } else if (event.getUserData().editedProperty === 'handleSide'
                && ((this.selectedItem as Door).nbDoors === 1 || (this.selectedItem as Window).nbCasement === 1)) {
                value = !value ? SceneConstants.HandleSide.handle_left : SceneConstants.HandleSide.handle_right;

            } else if (event.getUserData().editedProperty === 'shapeType') {
                value = value ? 1 : 0;
            }

            // Normal property field of an entity
            if ((this.selectedItem as any)[event.getUserData().editedProperty] !== undefined && event.getUserData().editedProperty !== 'isSpecialWall') {
                (this.selectedItem as any)[event.getUserData().editedProperty] = value;
            }
            else {
                // Property not found, check if this is a functionality chip and in that case, set the property in data if it exists
                if (this.selectedItem.isFunctionalityChipEntity()) {
                    if ((this.selectedItem as Room).getData(event.getUserData().editedProperty) !== undefined) {
                        (this.selectedItem as Room).setData(event.getUserData().editedProperty, value)
                    }
                }
            }

            // Post update rolling sutter
            if (event.getUserData().editedProperty === 'orientation') {
                for (var j = 0; j < this.selectedItem.children.length; j++) {
                    var joinChild = this.selectedItem.children[j] as TechnicalElement;

                    if (joinChild.entityType === SceneConstants.EntityType.TechnicalElement &&
                        joinChild.objectId === SceneConstants.TechnicalElementType.ceilingBox &&
                        (joinChild as CeilingBox).ceilingBoxType === SceneConstants.CeilingBoxType.rollingShutter) {
                        joinChild.length = (this.selectedItem as TechnicalElement).length;

                        var position = math.vec3.create();

                        if ((this.selectedItem as Joinery).orientation) {
                            math.vec3.set(position, 0, -(this.selectedItem.parent as Wall).thickness / 2, (this.selectedItem as Joinery).height + this.selectedItem.floorHeight);
                        } else {
                            math.vec3.set(position, 0, (this.selectedItem.parent as Wall).thickness / 2, (this.selectedItem as Joinery).height + this.selectedItem.floorHeight);
                        }
                        joinChild.transform.localPosition = position;
                    }
                }
            }

            this.actionEditEntity(this.selectedItem);
        }
        this.hasBeenEdited = true;
    }

    capValue(property: any, value: any) {
        return this.selectedItem!.addToCappedProperty(property, value);
    }

    actionEditEnded() {
        var planManager = PlanManager.getInstance();
        
        if (this.selectedItem != null && this.selectedItem.temporary !== null) {
            var isValid = this.selectedItem.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!);
            if (!isValid) {
                if (this.selectedItem instanceof Joinery) {
                    isValid = this.selectedItem.adaptJoinerySizeAndPosition();
                }
            }
            if (!isValid) {
                this.selectedItem.endTemporary();
            }
            else {
                if (this.selectedItem instanceof Joinery) {
                    planManager.executeCommand(new Commands.EditJoineryCommand(this.selectedItem));
                    EntityDefaultPropertiesManager.getInstance().setJoineryDefaultProperties(this.selectedItem);
                }
                else if (this.selectedItem instanceof Wall) {
                    planManager.executeCommand(new Commands.EditWallPropertiesCommand(this.selectedItem));
                }
                else if (this.selectedItem instanceof Room) {
                    planManager.executeCommand(new Commands.EditRoomPropertiesCommand(this.selectedItem));
                }
                else if (this.selectedItem.isTechnicalElementEntity()) {
                    planManager.executeCommand(new Commands.EditTechnicalElementCommand(this.selectedItem as TechnicalElement));
                }
                else if (this.selectedItem.isStaircaseEntity()) {
                    planManager.executeCommand(new Commands.EditStaircaseCommand(this.selectedItem as Staircase));
                }
                else if (this.selectedItem instanceof FunctionalityChip) {
                    planManager.executeCommand(new Commands.EditFunctionalityChipCommand(this.selectedItem));
                }
                else if (this.selectedItem instanceof Comment) {
                    planManager.executeCommand(new Commands.EditCommentCommand(this.selectedItem));
                }
                else if (this.selectedItem instanceof GeometryPrimitive) {
                    planManager.executeCommand(new Commands.EditGeometryPrimitiveCommand(this.selectedItem));
                }
            }
        }
        
        this.hasBeenEdited = false;
        if (this.selectedItem !== null) {
            if (this.selectedItem.endTemporary) {
                this.selectedItem.endTemporary();
            }
        }
        this.selectedItem = null;
        this.unselectChip();
    }

    actionTextFieldEdit(property: any, value: any, obj: any, isLast?: any) {
        this.selectedItem = obj;
        if (!this.hasBeenEdited) {
            this.startEdit();
        }
        else {
            if (this.selectedItem !== null && this.selectedItem.temporary) {
                this.selectedItem.temporary.recomputeValidity = true;
            }
        }
        if (this.selectedItem != null) {
            if ((this.selectedItem as any)[property] !== undefined) {
                (this.selectedItem as any)[property] = value;
            }
        }
        this.hasBeenEdited = true;
    }

    actionTextFieldEditEnded(property: any, value: any, obj: any, isLast?: any) {
        this.selectedItem = obj;
        if (!this.hasBeenEdited) {
            this.startEdit();
        }
        else {
            if (this.selectedItem !== null && this.selectedItem.temporary) {
                this.selectedItem.temporary.recomputeValidity = true;
            }
        }
        if (this.selectedItem != null) {
            var isNotCm = property === GUIConstants.NB_DOORS || property === GUIConstants.NB_CASEMENTS;

            // Normal property field of an entity

            if (property === 'lightColor') {
                (this.selectedItem as any)[property] = value;
            }
            else if ((this.selectedItem as any)[property] !== undefined) {
                this.capValue(property, isNotCm ? value / 10 - (this.selectedItem as any)[property] : value - (this.selectedItem as any)[property]);
            }
            else {
                // Property not found, check if this is a functionality chip and in that case, set the property in data if it exists
                if (this.selectedItem instanceof FunctionalityChip) {
                    if (this.selectedItem.getData(property) !== undefined) {
                        this.capValue(property, isNotCm ? value / 10 - this.selectedItem.getData(property) : value - this.selectedItem.getData(property));
                    }
                }
            }
            this.actionEditEntity(this.selectedItem);
        }
        this.hasBeenEdited = true;
    }

    keyPressed(keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        var planManager = PlanManager.getInstance();

        if (keyCode === cc.KEY.shift) {
            this.shiftPressed = true;
        }
        if (keyCode === cc.KEY.ctrl) {
            this.ctrlPressed = true;
        }
        if (keyCode === cc.KEY.escape) {
            this.actionEscape();
            return (null);
        }
        if (keyCode === cc.KEY.Delete || keyCode === cc.KEY.backspace) {
            this.actionDelete();
            return null;
        }

        if (keyCode === cc.KEY.l) {
            if (!this.ctrlPressed && !this.shiftPressed) {
                for (var i = 0; i < planManager.selectedEntities.length; i++) {
                    planManager.selectedEntities[i].locked = !planManager.selectedEntities[i].locked;
                }
            }
            else {
                var locked = this.ctrlPressed;
                var walls = planManager.world.currentScene!.currentFloor!.walls;
                var techElements = planManager.world.currentScene!.currentFloor!.technicalElementsWithStaircases;
                var joineries = planManager.world.currentScene!.currentFloor!.joineries;

                for (var i = 0; i < walls.length; i++) {
                    walls[i].locked = locked;
                }
                for (var i = 0; i < techElements.length; i++) {
                    techElements[i].locked = locked;
                }
                for (var i = 0; i < joineries.length; i++) {
                    joineries[i].locked = locked;
                }
            }
        }
        if (keyCode === cc.KEY.e) {
            if (planManager.selectedEntities.length === 1 && planManager.selectedEntities[0].locked !== true && (
                planManager.selectedEntities[0].isTechnicalElementEntity())) {
                return new EditEntityState(planManager.selectedEntities[0], planManager._uiState.cursorPosition, true, EditModeEnum.rotate);
            }
        }

        if (keyCode === cc.KEY.v) {
            var change = false;
            for (var i = 0; i < planManager.selectedEntities.length; i++) {
                if (planManager.selectedEntities[i].isJoineryEntity()) {
                    if (this.supportRollingShutter(planManager.selectedEntities[i])) {
                        var rollingShutter = this.getRollingShutter(planManager.selectedEntities[i]);

                        if (rollingShutter !== null) {
                            this.removeRollingShutter(rollingShutter);
                        }
                        else {
                            rollingShutter = this.addRollingShutter(planManager.selectedEntities[i]);
                            this.updateRollingShutterPosition(rollingShutter);
                        }

                        change = true;
                    }
                }
            }
            if (!change) {
                this.scaleModeOn = true;
            }
        }

        if (keyCode === cc.KEY.r) {
            this.rotateModeOn = true;
        }
        if (keyCode === cc.KEY.s) {
            this.symetryModeOn = true;
        }
        if (keyCode === cc.KEY.t) {
            this.translateModeOn = true;
        }
        if (keyCode === cc.KEY.d) {
            if (this.selectedItem !== null) {
                if (!this.selectedItem.isRoomEntity()) {
                    var position;

                    if (this.selectedItem instanceof Wall) {
                        // position = (this.selectedItem.begin + this.selectedItem.end) / 2
                    }
                    else {
                        position = this.selectedItem.position;
                    }

                    // Check if the selected object is in a room
                    var room = position !== undefined ? roomManager.getRoomAtPosition(position, planManager.world.currentScene!.currentFloor!) : null;

                    if (room !== null) {
                        // Yes, draw dimensions for the room around the object (managed by game object manager)
                        GameObjectManager.drawObjectAroundDimension(this.selectedItem, room);
                    }
                }
            }
        }
        if (keyCode === cc.KEY.n) {
            for (var i = 0; i < planManager.selectedEntities.length; i++) {
                var entity = planManager.selectedEntities[i];
                if (entity instanceof Joinery) {
                    var positionToTest = math.vec3.create();
                    math.vec3.copy(positionToTest, entity.position);

                    if (this.shiftPressed) {
                        positionToTest[2] = entity.floorHeight + entity.height + (entity.wall.height - (entity.floorHeight + entity.height)) / 2;
                    }
                    else {
                        positionToTest[2] = entity.floorHeight / 2;
                    }
                    var joinery = joineryManager.getJoineryAtPositionWithType(positionToTest, SavaneConstants.PositionTolerance * 3, planManager.world.currentScene!.currentFloor!, entity.id, SceneConstants.JoineryType.niche);

                    if (!joinery) {
                        var niche = EntityFactory.getInstance().createJoinery(math.vec3.create(), SceneConstants.JoineryType.niche, entity.length) as Niche;
                        niche.parent = entity.parent;
                        math.mat4.copy(niche.transform.localMatrix, entity.transform.localMatrix);
                        if (this.shiftPressed) {
                            niche.height = entity.wall.height - (entity.floorHeight + entity.height);
                            niche.floorHeight = entity.floorHeight + entity.height;
                        }
                        else {
                            niche.height = entity.floorHeight;
                            niche.floorHeight = 0;
                        }
                        niche.orientation = !entity.orientation;
                        if (entity.wallInstallType === -1) {
                            niche.orientation = !niche.orientation;
                        }
                        niche.wallInstallType = 1;
                        niche.thickness = entity.wall.thickness - 80;
                        if (entity.wallInstallType === 0) {
                            niche.thickness = entity.wall.thickness / 2 - 50;
                        }
                        if (niche.height > 0 && niche.thickness > 0) {
                            niche.height += 10;
                            if (this.shiftPressed) {
                                niche.floorHeight -= 10;
                            }
                            planManager.executeCommand(new Commands.AddJoineryCommand(niche));
                        }
                    }
                }
            }
        }
        if (keyCode === cc.KEY.h) {
            let joinery = planManager.selectedEntities[0] as Joinery;
            if (joinery instanceof Joinery) {
                joinery.startTemporary();
                if (!joinery.bottomTransom) {
                    joinery.floorHeight = 0;
                }
                if (!joinery.transom) {
                    joinery.height = joinery.wall.height - joinery.floorHeight;
                } else {
                    joinery.height += joinery.floorHeight;
                }
                planManager.executeCommand(new Commands.EditJoineryCommand(joinery));
            }
        }

        if (keyCode === cc.KEY.x) {
            if (planManager.selectedEntities.length === 1) {
                if (planManager.selectedEntities[0] instanceof Joinery) {
                    let joinery = planManager.selectedEntities[0];

                    joinery.startTemporary();
                    joinery.length = joineryManager.findMaxJoineryLength(joinery);

                    var bbox = joinery.wall.boundingBoxCut;
                    var invertMat = math.mat4.create();
                    var wallMatrix = joinery.wall.globalMatrix;
                    math.mat4.invert(invertMat, wallMatrix);
                    for (let i = 0; i < bbox.length; i++) {
                        math.vec3.transformMat4(bbox[i], bbox[i], invertMat);
                    }
                    var begPoint = null;
                    if (bbox[0][0] > bbox[1][0]) {
                        begPoint = bbox[0];
                    } else {
                        begPoint = bbox[1];
                    }

                    joinery.transform.localMatrix[12] = begPoint[0] + (joinery.length / 2);
                    planManager.executeCommand(new Commands.EditJoineryCommand(joinery));
                }
            }
        }

        if (keyCode === cc.KEY.o) {
            // Toggle holdout
            for (var i = 0; i < planManager.selectedEntities.length; ++i) {
                var entity = planManager.selectedEntities[i];
                entity.holdout = !entity.holdout;
                eventsManager.instance.dispatch(Events.COMMAND_EXECUTED, {
                    name: Commands.CommandEnum.ChangeCoatingCommand,
                    undo: false,
                    datas: {entity: entity, component: {}}
                });
            }
        }

        if (this.ctrlPressed && keyCode === cc.KEY.c) {
            if (planManager.selectedEntities.length === 1) {
                var entity = planManager.selectedEntities[0];
                if (planManager.selectedEntities[0].isWallEntity()) {
                    EntityDefaultPropertiesManager.getInstance().setDecoratedWallClipboard(entity as Wall);
                } else if (planManager.selectedEntities[0].isJoineryEntity()) {
                    EntityDefaultPropertiesManager.getInstance().setJoineryClipboard(entity as Joinery);
                }
            }
        }
        if (this.ctrlPressed && keyCode === cc.KEY.v) {
            if (planManager.selectedEntities.length === 1) {
                var entity = planManager.selectedEntities[0];
                if (entity instanceof Wall) {
                    if (EntityDefaultPropertiesManager.getInstance().getDecoratedWallClipboard()) {
                        var wall = EntityDefaultPropertiesManager.getInstance().getDecoratedWallClipboard();
                        entity.startTemporary();
                        entity.height = wall!.height;
                        entity.thickness = wall!.thickness;
                        entity.forceNoPlinth = wall!.forceNoPlinth;
                        entity.forceNoCornice = wall!.forceNoCornice;
                        // (entity as any).isSpecialWall = wall.isSpecialWall;
                        var components = wall!.getComponents(ComponentConstants.ComponentType.WallType);
                        var newComponents = [];
                        if (components.length > 0) {
                            newComponents.push(components[0].clone());
                        }
                        var coatings = wall!.getComponents(ComponentConstants.ComponentType.Coating);
                        for (var i = 0; i < coatings.length; ++i) {
                            newComponents.push(coatings[i].clone());
                        }
                        planManager.executeCommand(new Commands.CopyPasteWallAndComponentsCommand(entity as Wall, newComponents));
                    }
                } else if (entity.isJoineryEntity()) {
                    if (EntityDefaultPropertiesManager.getInstance().getJoineryClipboard()) {
                        var joinery = EntityDefaultPropertiesManager.getInstance().getJoineryClipboard();
                        planManager.executeCommand(new Commands.ReplaceJoineryCommand(joinery!, entity as Joinery));
                    }
                }
            }
        }

        return super.keyPressed(keyCode);
    }

    keyUnPressed(keyCode: number, ctrl?: boolean, maj?: boolean) {
        var planManager = PlanManager.getInstance();

        if (keyCode === cc.KEY.shift) {
            this.shiftPressed = false;
        }
        if (keyCode === cc.KEY.ctrl) {
            this.ctrlPressed = false;
        }
        // Scaling mode
        if (keyCode === cc.KEY.v) {
            this.scaleModeOn = false;
        }
        if (keyCode == cc.KEY.d) {
            GameObjectManager.deleteObjectAroundDimension();
        }
        if (this.scaleModeOn && (keyCode === cc.KEY.up || keyCode === cc.KEY.down)) {
            // Create command
            var entitySelected = null;
            if (planManager.selectedEntities != null && planManager.selectedEntities.length > 0) {
                entitySelected = planManager.selectedEntities[0];
            }
            var command = new Commands.ScaleFloorCommand(entitySelected, keyCode == cc.KEY.up, undefined as any, planManager.world.currentScene!.currentFloor!);
            if ((command as any).factor !== 1.0) {
                //If the command ask for a scale of 1.0, the command is useless so don't proceed
                planManager.executeCommand(command);
                //Redraw selected wall
                if (entitySelected !== null && entitySelected.entityType === SceneConstants.EntityType.Wall) {
                    //Redraw wall dimensions
                    GameObjectManager.drawWall(entitySelected, true, true, false);
                }
            }
            return null;
        }

        // Rotation mode
        if (keyCode === cc.KEY.r) {
            this.rotateModeOn = false;
        }
        if (this.rotateModeOn) {
            if (keyCode === cc.KEY.left) {
                planManager.executeCommand(new Commands.RotateFloorCommand(-1, planManager.world.currentScene!.currentFloor!));
            }
            if (keyCode === cc.KEY.right) {
                planManager.executeCommand(new Commands.RotateFloorCommand(1, planManager.world.currentScene!.currentFloor!));
            }
            if (keyCode === cc.KEY.up) {
                planManager.executeCommand(new Commands.RotateFloorCommand(-10, planManager.world.currentScene!.currentFloor!));
            }
            if (keyCode === cc.KEY.down) {
                planManager.executeCommand(new Commands.RotateFloorCommand(10, planManager.world.currentScene!.currentFloor!));
            }
        }

        // Symetry mode
        if (keyCode == cc.KEY.s) {
            this.symetryModeOn = false;
        }
        if (this.symetryModeOn) {
            if ((keyCode === cc.KEY.left) || (keyCode === cc.KEY.right)) {
                planManager.executeCommand(new Commands.SymetryFloorCommand('vertical', planManager.world.currentScene!.currentFloor!));
            }
            if ((keyCode === cc.KEY.up) || (keyCode === cc.KEY.down)) {
                planManager.executeCommand(new Commands.SymetryFloorCommand('horizontal', planManager.world.currentScene!.currentFloor!));
            }
        }

        // Translation mode
        if (keyCode == cc.KEY.t) {
            this.translateModeOn = false;
        }
        if (this.translateModeOn) {
            if (keyCode === cc.KEY.left) {
                planManager.executeCommand(new Commands.TranslateFloorCommand(-100, 0, planManager.world.currentScene!.currentFloor!));
            }

            if (keyCode === cc.KEY.right) {
                planManager.executeCommand(new Commands.TranslateFloorCommand(100, 0, planManager.world.currentScene!.currentFloor!));
            }

            if (keyCode === cc.KEY.up) {
                planManager.executeCommand(new Commands.TranslateFloorCommand(0, 100, planManager.world.currentScene!.currentFloor!));
            }

            if (keyCode == cc.KEY.down) {
                planManager.executeCommand(new Commands.TranslateFloorCommand(0, -100, planManager.world.currentScene!.currentFloor!));
            }
        }

        // Key c, m or i management to change wall thickness to 0m
        if (!this.ctrlPressed && (keyCode === cc.KEY.c || keyCode === cc.KEY.m || keyCode === cc.KEY.i)) {
            // Get selected entities
            var selectedEntities = planManager.selectedEntities;
            var newThickness: number = 0;

            switch (keyCode) {
                case cc.KEY.c:
                    newThickness = 70;
                    break;

                case cc.KEY.m:
                    newThickness = 200;
                    break;

                case cc.KEY.i:
                    newThickness = 340;
                    break;
            }

            var done = false;

            // Parse all selected entities searching for walls
            for (var i = 0; i < selectedEntities.length; i++) {
                if (selectedEntities[i].isWallEntity()) {
                    selectedEntities[i].startTemporary();
                    (selectedEntities[i] as Wall).thickness = newThickness;
                    planManager.executeCommand(new Commands.EditWallPropertiesCommand(selectedEntities[i] as Wall));
                    done = true;
                }
            }
            if (done) {
                planManager.updateItemsSelected(selectedEntities);
            }
        }

        // Key 0 or nompad0 management to change wall height to 0m
        if ((keyCode === cc.KEY.num0) || (keyCode === 48)) {
            // Get selected entities
            var selectedEntities = planManager.selectedEntities;

            // Parse all selected entities searching for walls
            for (var i = 0; i < selectedEntities.length; i++) {
                if (selectedEntities[i].isWallEntity()) {
                    selectedEntities[i].startTemporary();
                    (selectedEntities[i] as Wall).height = 0;
                    planManager.executeCommand(new Commands.EditWallPropertiesCommand(selectedEntities[i] as Wall));
                }
            }
            planManager.updateItemsSelected(selectedEntities);
        }

        // Key 1 or nompad1 management to change wall height to 1m
        if ((keyCode === cc.KEY.num1) || (keyCode === 49)) {
            // Get selected entities
            var selectedEntities = planManager.selectedEntities;

            // Parse all selected entities searching for walls
            for (var i = 0; i < selectedEntities.length; i++) {
                if (selectedEntities[i].isWallEntity()) {
                    selectedEntities[i].startTemporary();
                    (selectedEntities[i] as Wall).height = 1000;
                    planManager.executeCommand(new Commands.EditWallPropertiesCommand(selectedEntities[i] as Wall));
                }
                if (selectedEntities[i].isJoineryEntity()) {
                    selectedEntities[i].startTemporary();
                    if ((selectedEntities[i] as Door).nbDoors) {
                        (selectedEntities[i] as Door).nbDoors = 1;
                    }
                    if ((selectedEntities[i] as Window).nbCasement) {
                        (selectedEntities[i] as Window).nbCasement = 1;
                    }
                    planManager.executeCommand(new Commands.EditJoineryCommand(selectedEntities[i] as Joinery));
                }
            }
            if (planManager.selectedEntities.length > 1) {
                planManager.updateItemsSelected(selectedEntities);
            }
            else {
                planManager.updateItemsSelected(planManager.selectedEntities);
            }
        }

        // Key 2 or nompad2 management to change wall height
        if ((keyCode === cc.KEY.num2) || (keyCode === 50)) {
            // Get selected entities
            var selectedEntities = planManager.selectedEntities;

            // Parse all selected entities searching for walls
            for (var i = 0; i < selectedEntities.length; i++) {
                if (selectedEntities[i].isWallEntity()) {
                    var maxHeight = 0;

                    // Parse all wall's rooms and find the max Height
                    for (var j = 0; j < (selectedEntities[i] as Wall).rooms.length; j++) {
                        if ((selectedEntities[i] as Wall).rooms[j].height > maxHeight) {
                            maxHeight = (selectedEntities[i] as Wall).rooms[j].height;
                        }
                    }

                    selectedEntities[i].startTemporary();
                    // If maxHeight > 0 assign it or 2500mm as a default value
                    if (maxHeight > 0) {
                        (selectedEntities[i] as Wall).height = maxHeight;
                    }
                    else {
                        // No, then assign 2500 default height
                        (selectedEntities[i] as Wall).height = 2500;
                    }

                    planManager.executeCommand(new Commands.EditWallPropertiesCommand(selectedEntities[i] as Wall));
                }
                if (selectedEntities[i].isJoineryEntity()) {
                    selectedEntities[i].startTemporary();
                    if ((selectedEntities[i] as Door).nbDoors) {
                        (selectedEntities[i] as Door).nbDoors = 2;
                    }
                    if ((selectedEntities[i] as Window).nbCasement) {
                        (selectedEntities[i] as Window).nbCasement = 2;
                    }
                    planManager.executeCommand(new Commands.EditJoineryCommand(selectedEntities[i] as Joinery));
                }
            }
            if (planManager.selectedEntities.length > 1) {
                planManager.updateItemsSelected(selectedEntities);
            }
            else {
                planManager.updateItemsSelected(planManager.selectedEntities);
            }
        }

        if ((keyCode >= cc.KEY.num3 && keyCode <= cc.KEY.num4) || (keyCode >= 51 && keyCode <= 52)) {
            // Get selected entities
            var selectedEntities = planManager.selectedEntities;
            var num = 3;

            if (keyCode >= cc.KEY.num3 && keyCode <= cc.KEY.num4) {
                num += keyCode - cc.KEY.num3;
            }
            if (keyCode >= 51 && keyCode <= 52) {
                num += keyCode - 51;
            }

            for (var i = 0; i < selectedEntities.length; i++) {
                if (selectedEntities[i].isJoineryEntity() && ((selectedEntities[i] as Joinery).joineryType === SceneConstants.JoineryType.pictureWindow || (selectedEntities[i] as Joinery).joineryType === SceneConstants.JoineryType.canopy)) {
                    selectedEntities[i].startTemporary();
                    if ((selectedEntities[i] as Door).nbDoors) {
                        (selectedEntities[i] as Door).nbDoors = num;
                    }
                    if ((selectedEntities[i] as Window).nbCasement) {
                        (selectedEntities[i] as Window).nbCasement = num;
                    }
                    planManager.executeCommand(new Commands.EditJoineryCommand(selectedEntities[i] as Joinery));
                }
            }
        }

        if ((keyCode >= cc.KEY.num5 && keyCode <= cc.KEY.num9) || (keyCode >= 53 && keyCode <= 57)) {
            // Get selected entities
            var selectedEntities = planManager.selectedEntities;
            var num = 5;

            if (keyCode >= cc.KEY.num5 && keyCode <= cc.KEY.num9) {
                num += keyCode - cc.KEY.num5;
            }
            if (keyCode >= 53 && keyCode <= 57) {
                num += keyCode - 53;
            }

            for (var i = 0; i < selectedEntities.length; i++) {
                if (selectedEntities[i].isJoineryEntity() && (selectedEntities[i] as Joinery).joineryType === SceneConstants.JoineryType.canopy) {
                    selectedEntities[i].startTemporary();
                    if ((selectedEntities[i] as Window).nbCasement) {
                        (selectedEntities[i] as Window).nbCasement = num;
                    }
                    planManager.executeCommand(new Commands.EditJoineryCommand(selectedEntities[i] as Joinery));
                }
            }
        }

        if (keyCode >= cc.KEY.a && keyCode <= cc.KEY.z) {
            this.tryRenameRooms(planManager.selectedEntities, keyCode);
        }

        return super.keyUnPressed(keyCode);
    }

    getNewRoomFunctionnality(selectedEntity: any, keyCode: any) {
        var arrayIdx1 = 0;
        var roomFunctionalityId = -1;
        var roomFunctionality = selectedEntity.getComponent(ComponentConstants.ComponentType.Functionality);

        // Current functionnality
        if (roomFunctionality) {
            roomFunctionalityId = roomFunctionality.functionalityId;
        }

        // Search for keycode entry in the renameRoomArray
        while (arrayIdx1 < this.renameRoomArray.length && this.renameRoomArray[arrayIdx1].keyCode < keyCode) {
            arrayIdx1++;
        }
        // End of array
        if (arrayIdx1 >= this.renameRoomArray.length) {
            return(-1);
        }
        // No functionnality binded to this key
        if (this.renameRoomArray[arrayIdx1].keyCode !== keyCode) {
            return(-1);
        }
        // Here we are sure there is an entry for this keycode
        var arrayIdx2 = arrayIdx1;
        while(arrayIdx2 < this.renameRoomArray.length && this.renameRoomArray[arrayIdx2].keyCode === keyCode && this.renameRoomArray[arrayIdx2].functionalityId !== roomFunctionalityId) {
            arrayIdx2++;
        }
        arrayIdx2++;
        
        if (arrayIdx2 >= this.renameRoomArray.length || this.renameRoomArray[arrayIdx2].keyCode !== keyCode) {
            return(arrayIdx1);
        }
        else {
            return(arrayIdx2);
        }
    }

    tryRenameRooms(selectedEntities: any, keyCode: any) {
        for (var i = 0; i < selectedEntities.length; i++) {
            if (selectedEntities[i].isRoomEntity()) {
                var changeName = false;
                var newFunctionalityId;
                var newName;
                var newRoomFunctionality = this.getNewRoomFunctionnality(selectedEntities[i], keyCode);

                if (newRoomFunctionality !== -1) {
                    newFunctionalityId = this.renameRoomArray[newRoomFunctionality].functionalityId;
                    newName = this.renameRoomArray[newRoomFunctionality].functionalityName;
                    changeName = true;
                }

                if (changeName) {
                    eventsManager.instance.dispatch(Events.MAINFUNCTIONALITY_CHANGE, {
                        data: {id: newFunctionalityId, name: newName},
                        room: selectedEntities[i],
                        debounce: 1000
                    });
                }
            }
        }
    }

    unselectChip() {
        if (this.chipEdited !== null && this.chipEdited !== undefined) {
            //set state to selected
            var layer = PlanManager.getInstance().scrollWindow.grid;
            var name = 'FunctionalityChip' + this.chipEdited.id;
            // var sprite = layer.getChildByName(name);
            var sprite = Utils.getChildByNameRecursivly(layer, name);
            if (sprite !== null) {
                sprite.setSelected(false);
            }
        }

        this.chipEdited = null;
    }
    // addRoomFunc(functionality, room, edit) {
    //     var funcList = room.secondaryFunctionalities;
    //     for (var i = 0; i < funcList.length; i++) {
    //         if (funcList[i].functionalityId === functionality.id) {
    //             this.removeRoomFunc(functionality, room, edit);
    //             break;
    //         }
    //     }
    //     room.addSecondaryFunctionality(functionality.id, functionality.name, functionality.medias.md, functionality.hover.md);
    //     eventsManager.instance.dispatch(Events.ROOM_SECONDARY_FUNCTIONALITY_CHANGED, {
    //         room: room,
    //         functionalityality,
    //         edit: edit
    //     });
    // }
    // removeRoomFunc(functionality, room, edit) {
    //     var chips = room.functionalityChips;
    //     var chip = null;
    //     for (var i = 0; i < chips.length; i++) {
    //         if (chips[i].functionality === functionality.id) {
    //             chip = chips[i];
    //             break;
    //         }
    //     }
    //     if (chip !== null) {
    //         GameObjectManager.deleteFunctionalityChip(chip);
    //     }
    //     room.removeFunctionality(functionality.id);
    //     eventsManager.instance.dispatch(Events.ROOM_SECONDARY_FUNCTIONALITY_CHANGED, {
    //         room: room,
    //         functionalityality,
    //         edit: edit
    //     });
    // }

    // changeToChipFunctionalityEdition(functionality, room) {
    //     var chips = room.functionalityChips;
    //     var chip = null;
    //     for (var i = 0; i < chips.length; i++) {
    //         if (chips[i].functionality === functionality.id) {
    //             chip = chips[i];
    //         }
    //     }
    //     if (chip !== null) {
    //         //TODO Find a way to remove the call to plan manager ?
    //         var newState = new MoveFunctionalityChipState(room, chip, PlanManager.getInstance()._uiState.cursorPosition, true);
    //         eventsManager.instance.dispatch(Events.CHANGE_STATE, newState);
    //     } else {
    //         eventsManager.instance.dispatch(Events.ADD_ROOM_SECONDARY_FUNCTIONALITY, {
    //             functionalityality,
    //             room: room,
    //             edit: true
    //         });
    //     }
    // }
    /**
     * Change to edition of entity, if entity is null go to creation state
     *
     *
     * @param type
     * @param entity
     * @param entityParam
     */
    changeToEntityEdition(entity: any) {
        var newState = null;
        if (entity !== null) {
            switch (entity.entityType) {
                case SceneConstants.EntityType.WorkTop:
                    return;
                case SceneConstants.EntityType.Wall:
                    EntityDefaultPropertiesManager.getInstance().wallDefaultProperties.thickness = entity.thickness;
                    newState = new IdleCreateState(PlanManager.getInstance().vectorDraw);
                    break;
                case SceneConstants.EntityType.Room:
                    EntityDefaultPropertiesManager.getInstance().wallDefaultProperties.thickness = entity.thickness;
                    newState = new AddRoomState(entity.roomType);
                    break;
                case SceneConstants.EntityType.Joinery:
                    EntityDefaultPropertiesManager.getInstance().convertJoineryToDefaultProperties(entity);
                    entity.length = PlanManager.getInstance().joineriesLength[entity.joineryType];
                    newState = new AddJoineryState(entity);
                    break;
                default:
                    newState = new AddEntityState(entity, undefined);
                    break;
            }
        }
        eventsManager.instance.dispatch(Events.CHANGE_STATE, newState);
    }

    changeToComponentEdition(data: any) {
        var newState = null;
        switch (data.type) {
            case ComponentConstants.ComponentType.Area:
                newState = new AreaState(null, null);
                break;
            default:
                break;
        }
        if (newState) {
            eventsManager.instance.dispatch(Events.CHANGE_STATE, newState);
        }
    }

    dispose() {
        this.actionEditEnded();

        PlanManager.getInstance().scrollWindow._cancelDragging();
        this.unselectChip();
        //Remove hoverDrawings
        GameObjectManager.deleteJunctionPoint('HoverJunctionPoint');
        //Detach listeners
        eventsManager.instance.removeListener(this.entityEdition);
        eventsManager.instance.removeListener(this.chipFuncEditionListener);
        eventsManager.instance.removeListener(this.chipFuncAddListener);
        eventsManager.instance.removeListener(this.chipFuncRemoveListener);
        eventsManager.instance.removeListener(this.plusListener);
        eventsManager.instance.removeListener(this.lessListener);
        eventsManager.instance.removeListener(this.textFieldEndListener);
        eventsManager.instance.removeListener(this.textFieldListener);
        eventsManager.instance.removeListener(this.deleteListener);
        eventsManager.instance.removeListener(this.unselectListener);
        eventsManager.instance.removeListener(this.sliderListener);
        eventsManager.instance.removeListener(this.componentEdition);
    }
}